import { useState } from 'react';
import { Carousel, useBreakpoint, GenericLink, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import type StandardBannerNoCTAProps from '../StandardBannerNoCTA/types/propsTypes';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import { ImageDefination } from '../types/common';
import styles from './StandardBannerNoCTA.module.scss';

const StandardBannerNoCTA = ({ images }: StandardBannerNoCTAProps) => {
  const viewPortType = useBreakpoint();
  const [imgLoading, setImgLoading] = useState(true);

  const imageDetails: ImageDefination[] = [];

  images.forEach((bannerImage) => {
    const frontImage = bannerImage.imageList.find((item) => item.viewport?.includes(viewPortType));
    if (frontImage) {
      imageDetails.push({
        url: frontImage.url,
        altText: frontImage.altText,
        viewport: frontImage.viewport,
      });
    }
  });

  return (
    <div className={styles['standard-banner-no-cta-carousel-container']}>
      <Carousel hideButtons={false} id={'StandardBannerNoCTA-Carousel'} isTileCarousel={false}>
        {imageDetails.length > 0 ? (
          imageDetails.map(({ url, altText }, index) => (
            <div
              key={`standard-banner-no-cta-${index.toString()}`}
              className={`${styles['standard-banner-no-cta-container']} ${
                images[index]?.redirectionInfo?.url ? styles['standard-banner-no-cta-link'] : ''
              }`}
            >
              {images[index]?.redirectionInfo?.url ? (
                <GenericLink
                  href={images[index]?.redirectionInfo?.url}
                  target={images[index]?.redirectionInfo?.target}
                  aria-label={altText}
                >
                  <NextgenImage
                    src={url}
                    alt={altText}
                    className={styles['standard-banner-no-cta-bg-image']}
                    onLoad={() => setImgLoading(false)}
                    loaderType={LoaderType.CONTENTSTACK}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    priority={index === 0 ? true : false}
                  />
                  {imgLoading && (
                    <SkeletonLoader className={styles['standard-banner-no-cta-bg-image']} borderRadius={12} />
                  )}
                </GenericLink>
              ) : (
                <>
                  <NextgenImage
                    src={url}
                    alt={altText}
                    className={styles['standard-banner-no-cta-bg-image']}
                    onLoad={() => setImgLoading(false)}
                    loaderType={LoaderType.CONTENTSTACK}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    priority={index === 0 ? true : false}
                  />
                  {imgLoading && (
                    <SkeletonLoader className={styles['standard-banner-no-cta-bg-image']} borderRadius={12} />
                  )}
                </>
              )}
            </div>
          ))
        ) : (
          <div key={`standard-banner-no-cta-0`} className={styles['standard-banner-no-cta-container']}>
            <SkeletonLoader className={styles['standard-banner-no-cta-bg-image']} borderRadius={12} />
          </div>
        )}
      </Carousel>
    </div>
  );
};

export default StandardBannerNoCTA;
